var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chooser-component"},[_c('ul',{staticClass:"chooser-list"},_vm._l((_vm.selections),function(item,index){return _c('li',{class:{active: _vm.checkActive(index)},attrs:{"title":item.label},on:{"click":function($event){return _vm.toggleSelection(index)}}},[_vm._v(_vm._s(item.label)+"\n    ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e755f46c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/multiplyChooser.vue
// module id = null
// module chunks = 